
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CameraStationDetailsWithoutImages"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CameraStation"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"index"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"floorLevel"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"userCreatedDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"position"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"y"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"timepoints"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":158}};
    doc.loc.source = {"body":"fragment CameraStationDetailsWithoutImages on CameraStation {\n  id\n  index\n  label\n  floorLevel\n  userCreatedDate\n  position {\n    x\n    y\n  }\n  timepoints\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
